import React, { useState } from "react";

import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import FilesFormGeneral from "./FilesFormGeneral";
import FilesFormSystem from "./FilesFormSystem";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      style={{
        display: value === index ? "block" : "none",
        minHeight: "400px",
      }}
      id={`x-tabpanel-${index}`}
      aria-labelledby={`x-tab-${index}`}
      {...other}
    >
      {<Box>{children}</Box>}
    </div>
  );
}

export default function FilesForm({ formData, handleInputChange }) {
  const [tabIndex, setTabindex] = useState(0);
  const handleTabSwitch = (event, newValue) => {
    setTabindex(newValue);
  };
  return (
    <>
      <Tabs
        value={tabIndex}
        onChange={handleTabSwitch}
        sx={{ marginBottom: "2rem" }}
      >
        <Tab label="Allmänt" />
        <Tab label="System" />
      </Tabs>
      <TabPanel value={tabIndex} index={0}>
        <FilesFormGeneral
          formData={formData}
          handleInputChange={handleInputChange}
        />
      </TabPanel>
      <TabPanel value={tabIndex} index={1}>
        <FilesFormSystem
          formData={formData}
          handleInputChange={handleInputChange}
        />
      </TabPanel>
    </>
  );
}
